/*
 * @Author: 郭洪宇 guohongyu@chinasofti.com
 * @Date: 2022-07-18 13:59:51
 * @LastEditors: ghy
 * @LastEditTime: 2023-08-09 14:15:02
 * @FilePath: \cigbus-vue-cdp-ma\src\api\objectRelationshipManage.js
 * @Description: 
 */
import axios from './index'
export const API_MAIN = '/api'

/**
 * @description:政策文件树
 * 
 * @param {
 * }
 * @return {*}
 */
export const findPolicySortTreeList = (data) => {
    return axios.request({
        url: `${API_MAIN}/findPolicySortTreeList`,
        method: 'post',
        data
    })
}

/**
 * @description:政策文件分页
 * 
 * @param {
* }
* @return {*}
*/
export const findCheckedPolicyFilePage = (data) => {
   return axios.request({
       url: `${API_MAIN}/findCheckedPolicyFilePage`,
       method: 'post',
       data
   })
}

/**
 * @description:政策文件详情
 * 
 * @param {
* }
* @return {*}
*/
export const findPolicyFileDetail = (data) => {
   return axios.request({
       url: `${API_MAIN}/findPolicyFileDetail`,
       method: 'post',
       data
   })
}





// WEBPACK FOOTER //
// ./src/api/policy.js